import React, { useEffect, useState } from 'react'
import ErrorBoundary from '../../../../components/FundDetails/Modules/Performance/ErrorBoundary.jsx'
import * as StringFormatter from '../../../../global/formatters/string-formatter.js'
import DOMPurify from 'dompurify'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import Loader from '../../../../components/FundDetails/Modules/Shared/Loader.jsx'
import { stickyOnScroll } from '../helpers/InvestmentProductsHelper.js'
import combineMorningstarfundsReducer, {
  productsConfig,
  filterData,
} from './allProductTypesReducer.js'
import Filters from './AllProductTypesFilters.jsx'
import {
  renderColumnHeader,
  renderColumnCell,
  sortFunds,
} from '../combineMorningstarFunds/combineMorningstarFundsHelper.jsx'

function AllProductTypes() {
  const urlParams = new URLSearchParams(window.location.search)
  const [tableHeaderTop, setTableHeaderTop] = useState(0)
  const state = combineMorningstarfundsReducer(urlParams)
  const {
    isLoading,
    rowsData,
    selectedSort,
    selectedSortType,
    selectedSortDirection,
    onClickSort,
    selected,
    searchInput,
    sortData,
  } = state

  useEffect(() => {
    stickyOnScroll(setTableHeaderTop)
  }, [])
  const getAspect = () => {
    const _aspects = {
      columns: [
        {
          name: 'symbol',
          className:
            'Table-header u-textNormal sorting bordered u-paddingTop5gu' +
            (selectedSort === 'symbol'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Ticker: activate to sort column descending',
          content: <>Ticker</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'symbol' ? ' Icon--before' : ''),
            sort: 'symbol',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => <div>{fund.symbol}</div>,
          },
        },
        {
          name: 'fundName',
          className:
            'Table-header u-textNormal sorting bordered  u-paddingTop5gu' +
            (selectedSort === 'fundName'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Fund Name: activate to sort column descending',
          content: <>Fund Name</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'fundName' ? ' Icon--before' : ''),
            sort: 'fundName',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => (
              <div>
                <span className="u-textSecondary u-block">
                  <a
                    href={DOMPurify.sanitize(
                      getRelativeBasePath() +
                        `/investment-products/${fund.fundType}/${StringFormatter.urlSafe(fund.fundName)}/Class-${
                          fund?.fundClass ? fund?.fundClass : 'none'
                        }/details/?cusip=${fund.cusip}`
                    )}
                  >
                    {fund.fundName}
                  </a>
                </span>
                <span>
                  {fund.fundClass && `Class - ${fund.fundClass}`}&nbsp;
                </span>
              </div>
            ),
          },
        },
        {
          name: 'productType',
          className:
            'Table-header u-textNormal sorting bordered  u-paddingTop5gu' +
            (selectedSort === 'productType'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Fund Type: activate to sort column descending',
          content: <>Fund Type</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'productType' ? ' Icon--before' : ''),
            sort: 'productType',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => (
              <span>{productsConfig[fund.productType].label}</span>
            ),
          },
        },
        {
          name: 'ctgName',
          className:
            'Table-header u-textNormal sorting bordered  u-paddingTop5gu' +
            (selectedSort === 'ctgName'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Asset Class: activate to sort column descending',
          content: <>Asset Class</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'ctgName' ? ' Icon--before' : ''),
            sort: 'ctgName',
            sortType: 'string',
          },
          cell: {
            className: ' bordered-right',
            content: (fund) => <span>{fund.assetClass}</span>,
          },
        },
        {
          name: 'subCtgValue',
          className:
            'Table-header u-textNormal sorting  u-paddingTop5gu' +
            (selectedSort === 'subCtgValue'
              ? selectedSortDirection
                ? ' is-ascending'
                : ' is-descending'
              : ''),
          ariaLabel: 'Morningstar Category: activate to sort column',
          content: <>Morningstar Category</>,
          button: {
            className:
              'Table-headerNode u-padding2gu u-paddingRight4gu' +
              (selectedSort === 'subCtgValue' ? ' Icon--before' : ''),
            sort: 'subCtgValue',
            sortType: 'array',
          },
          cell: {
            content: (fund) => fund.subCtgValue,
          },
        },
      ],
    }

    return _aspects
  }
  const aspect = getAspect()

  const tableRowData = filterData(selected, searchInput, rowsData)

  return (
    <>
      <Filters {...state} tableRowData={rowsData} urlParams={urlParams} />
      {isLoading ? (
        <Loader showBackground={false} />
      ) : (
        <>
          <div className="Form-label">
            Displaying{' '}
            <span
              className="u-textBold"
              data-qa-automation="displayingFundCount"
            >
              {tableRowData?.length || 0}
            </span>{' '}
            fund(s)
          </div>
          <table className="Table Table--reversed Table--sortable u-sm-block u-overflowX InvestmentProductTable">
            <thead
              role="rowgroup"
              className="Table-head is-sticky"
              style={{
                top: tableHeaderTop,
              }}
            >
              <tr role="row" className="Table-row">
                {aspect.columns.map((column) =>
                  renderColumnHeader(column, selectedSortDirection, onClickSort)
                )}
              </tr>
            </thead>
            {tableRowData.length < 1 ? (
              <tbody className="Table-body Table-row">
                <tr>
                  <td className="Table-cell" colSpan={12}>
                    No matching funds found.
                  </td>
                </tr>
              </tbody>
            ) : (
              sortFunds(
                tableRowData,
                selectedSortDirection,
                selectedSortType,
                selectedSort
              ).map((fund, idx) => {
                return (
                  <tbody
                    className="Table-body Table-row"
                    key={`${fund.fundType}-${idx}`}
                  >
                    <React.Fragment>
                      <tr role="row">
                        {aspect.columns
                          .filter((column) => !column.hide)
                          .map((column) =>
                            renderColumnCell(
                              {
                                ...column,
                                key: `${fund.fundType}-${idx}-${column.name}`,
                              },
                              fund
                            )
                          )}
                      </tr>
                    </React.Fragment>
                  </tbody>
                )
              })
            )}
          </table>
        </>
      )}
    </>
  )
}

export default function AllProductTypesContainer() {
  return (
    <div className="u-sizeConstrained Content investment-products">
      <ErrorBoundary
        title="Find a Product"
        message="Find a Product information is currently unavailable due to a technical issue. Please try again later."
        isConstrained={true}
      >
        <AllProductTypes />
      </ErrorBoundary>
    </div>
  )
}
